import { render } from "./index.vue?vue&type=template&id=38f48884&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=38f48884&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f48884"]])

export default __exports__